module.exports = __webpack_public_path__ + "static/hero-image-mystic-parker-7312939cfdc4297d935cc80a001a8916.jpg";